import {
    CssBaseline,
    StyledEngineProvider,
    ThemeProvider,
} from "@mui/material";
import React from "react";
import AppTheme from "Theme/AppTheme";
import AuthPage from "./AuthPage";
import ChangePassword from "./ChangePassword";

function ChangePasswordUser() {
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={AppTheme}>
                <CssBaseline />
                <AuthPage title="Reset your password" shouldShowLogo={false}>
                    <ChangePassword />
                </AuthPage>
            </ThemeProvider>
        </StyledEngineProvider>
    );
}

export default ChangePasswordUser;
